import { render, staticRenderFns } from "./laboratory-cancellation-modal-form.vue?vue&type=template&id=73592883&"
import script from "./laboratory-cancellation-modal-form.ts?vue&type=script&lang=ts&"
export * from "./laboratory-cancellation-modal-form.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports